import { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill"

type Props = {
    value: string;
    onChange: (text: string) => void;
}

export const CommunityRichText = ({  value, onChange }: Props) => {
    const quillRef = useRef<ReactQuill>(null);
    const MAX_LENGTH = 10000;
    return (
        <div className="w-100">
            <ReactQuill
                ref={quillRef}
                theme="snow"
                value={value}
                onChange={(content, delta, source, editor) => {
                    const text = editor.getText();
                    const length = text.length;                    

                    if (length >= MAX_LENGTH) {
                        const quill = quillRef.current?.getEditor();
                        quill?.deleteText(
                            MAX_LENGTH,
                            length - MAX_LENGTH
                        );
                        return;
                    }

                    onChange(content);
                }}
                style={{ width: '100%' }}
            />
        </div>
    )
}